/*eslint-disable*/
// chakra imports
import { toastError, toastWarning, presentMutationError } from "../../utils/showApiErrorToast";
import {
    Box,
    Button,
    Flex,
    Image,
    Link,
    Stack,
    VStack,
    Text,
    useColorModeValue,
    useBreakpointValue,
    useMediaQuery,
    Icon,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    MenuDivider,
    Portal,
    useDisclosure,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    Switch,
    Spinner,
} from "@chakra-ui/react";
// import { SidebarHelp } from "./SidebarHelp"; // Hidden documentation card
import React, { useState, useRef, useEffect, useCallback, RefObject } from "react";
import { useTheme } from "next-themes";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import { AiOutlineMenuFold, AiOutlineMenuUnfold, AiOutlineBell, AiOutlineMore, AiOutlineLogout } from "react-icons/ai";
import { MdSync, MdAccountBalance } from "react-icons/md";
import { FiArrowLeft, FiBell } from "react-icons/fi";
import type { AccountSettingsAnimatedIcon } from "../../constants/accountSettingsSidebar";
import { Avatar } from "@chakra-ui/react";
import { RouteConfigArray } from "../../types/routes";
import { useClerkAuth } from "../../hooks/useClerkAuth";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { useResyncTrades } from "../../hooks/useResyncTrades";
import { useActiveBrokerAccount } from "../../hooks/useActiveBrokerAccount";
import { useRunInstrumentSetupAfterSync } from "../../hooks/useRunInstrumentSetupAfterSync";
import { useActiveBrokerCapabilities } from "../../hooks/useActiveBrokerCapabilities";
import { invalidateTradeDataCaches } from "../../hooks/useTradeStatistics";
import avatar1 from "../../assets/img/avatars/avatar1.png";
import avatar2 from "../../assets/img/avatars/avatar2.png";
import avatar3 from "../../assets/img/avatars/avatar3.png";
import avatar4 from "../../assets/img/avatars/avatar4.png";
import {
  getSidebarBrandLogoSrc,
  SIDEBAR_BRAND_LOGO_COLLAPSED_SIZE,
  SIDEBAR_BRAND_LOGO_EXPANDED_MAX_HEIGHT,
  SIDEBAR_BRAND_LOGO_EXPANDED_MAX_WIDTH,
} from "../../constants/sidebarBrandLogo";
import { SidebarNavRouteRow } from "./SidebarNavRouteRow";
import {
  renderRouteIconWithAnimRef,
  useSidebarNavIconAnimation,
} from "./sidebarNavIconAnimation";
import { ItemContent } from "../Menu/ItemContent";
import { syncTradesFromBroker } from "../../services/tradeApi";
import { afterBrokerResyncWaitForAnalytics } from "../../utils/brokerSyncStatusPoll";
import GradientButton from "../../views/Dashboard/Profile/components/GradientButton";
import { AccountSelectorModal } from "./AccountSelectorModal";
import { formatAccountDisplayLabelShort, formatAccountDisplayLabel } from "../../services/liquidBrokersApi";
import NotificationModal from "../Notifications/NotificationModal";
import {
  fetchNotifications,
  FetchNotificationsParams,
} from "../../services/notificationsApi";
import {
  getPerformanceSummaryPreviewText,
  isPerformanceSummaryEventKey,
  resolveNotificationDisplayTitle,
} from "../../utils/notificationDisplay";
import { CogIcon, type CogIconHandle } from "../ui/cog";
import { SunIcon, type SunIconHandle } from "../ui/sun";
import { MoonIcon, type MoonIconHandle } from "../ui/moon";
import { toast } from "sonner";
import {
  ACCOUNT_SETTINGS_RETURN_PATH_KEY,
  ACCOUNT_SETTINGS_TABS,
  accountSettingsTabPath,
  resolveAccountSettingsTabId,
} from "../../constants/accountSettingsSidebar";
import {
  NOTIFICATIONS_CENTRE_RETURN_PATH_KEY,
  notificationsCentrePath,
} from "../../constants/notificationsCentre";
import { findTradeAccount } from "../../utils/tradeAccountAnalytics";
import { shouldShowSidebarResyncTrades } from "../../utils/tradeAccountSource";
import { useBillingContext } from "../../contexts/BillingContext";
import { isProfileTabAllowedWithoutTier1 } from "../../utils/billingAllowlist";
interface SidebarContentProps {
  logoText: string;
  routes: RouteConfigArray;
  display?: string;
  sidebarVariant?: string;
  isCollapsed?: boolean;
  onToggleSidebar?: () => void;
  onOpen?: () => void;
  sidebarRef?: RefObject<HTMLDivElement>;
}

/** Account settings row with animated icons (hover + pointer-down). */
function AccountSettingsTabLink({
  tab,
  isActive,
  isCollapsed,
  activeBg,
  activeColor,
  inactiveColor,
}: {
  tab: (typeof ACCOUNT_SETTINGS_TABS)[number];
  isActive: boolean;
  isCollapsed: boolean;
  activeBg: string;
  activeColor: string;
  inactiveColor: string;
}): JSX.Element {
  const { iconAnimRef, linkHandlers } = useSidebarNavIconAnimation();
  const iconColor = isActive ? activeColor : inactiveColor;
  const TabIcon = tab.icon as AccountSettingsAnimatedIcon;

  return (
    <NavLink to={accountSettingsTabPath(tab.id)} {...linkHandlers}>
      <Box
        as="button"
        boxSize="initial"
        display="flex"
        justifyContent={isCollapsed ? "center" : "flex-start"}
        alignItems="center"
        bg={isActive ? activeBg : "transparent"}
        mb={{ xl: "12px" }}
        mx={{ xl: "auto" }}
        ps={isCollapsed ? "0" : "16px"}
        pe={isCollapsed ? "0" : "16px"}
        py="12px"
        borderRadius="6px"
        w={isCollapsed ? "44px" : "100%"}
        cursor="pointer"
        _hover={{ opacity: 0.9 }}
        _active={{ transform: "none" }}
        _focus={{ boxShadow: "none", outline: "none" }}
        transition="background 0.2s ease-linear, padding 0.2s ease-linear"
      >
        <Flex
          justifyContent={isCollapsed ? "center" : "flex-start"}
          alignItems="center"
          w="100%"
          position="relative"
        >
          <Box
            me={isCollapsed ? "0" : "12px"}
            transition="margin 0.2s ease-linear"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            color={iconColor}
            pointerEvents="none"
          >
            {renderRouteIconWithAnimRef(
              <TabIcon
                size={20}
                className="text-inherit"
                style={{ color: iconColor }}
                aria-hidden
              />,
              iconAnimRef
            )}
          </Box>
          {!isCollapsed && (
            <Text
              color={iconColor}
              my="auto"
              fontSize="sm"
              fontWeight={isActive ? "semibold" : "medium"}
              ml="0"
              flexShrink={0}
              fontFamily="'Urbanist', sans-serif"
            >
              {tab.label}
            </Text>
          )}
        </Flex>
      </Box>
    </NavLink>
  );
}

const SidebarContent: React.FC<SidebarContentProps> = ({ logoText, routes, isCollapsed = false, onToggleSidebar, onOpen, sidebarVariant, sidebarRef }) => {
  const history = useHistory();
  const { signOut, isLoaded, user } = useClerkAuth();
  const { isLoading: billingLoading, isTier1Granted } = useBillingContext();
  const { hasTradarAccess, isAdmin } = useFeatureFlags();
  const [isSigningOut, setIsSigningOut] = useState(false);
  const { isResyncing, setResyncing } = useResyncTrades();
  const {
    activeAccountCode,
    activeBrokerName,
    accounts: brokerAccounts,
    loading: accountsLoading,
    error: accountsError,
    isConnected: brokerConnected,
    setActiveTradeAccount,
    refetch: refetchBrokerAccounts,
    removeTradeAccount,
  } = useActiveBrokerAccount();
  const runInstrumentSetupAfterSync = useRunInstrumentSetupAfterSync();
  const { capabilities, loading: brokerCapabilitiesLoading } = useActiveBrokerCapabilities(
    activeAccountCode,
    activeBrokerName
  );
  const activeTradeAccount = React.useMemo(
    () => findTradeAccount(brokerAccounts, activeAccountCode, activeBrokerName),
    [brokerAccounts, activeAccountCode, activeBrokerName]
  );
  const showSidebarResyncTrades = React.useMemo(
    () =>
      shouldShowSidebarResyncTrades({
        activeAccountCode,
        activeBrokerName,
        activeAccount: activeTradeAccount,
        brokerSupportsAutoSync: capabilities?.auth?.supports_auto_sync,
        capabilitiesResolved: !brokerCapabilitiesLoading,
      }),
    [
      activeAccountCode,
      activeTradeAccount,
      capabilities?.auth?.supports_auto_sync,
      brokerCapabilitiesLoading,
    ]
  );
  const [isSwitchingAccount, setIsSwitchingAccount] = useState(false);
  const [isMobile] = useMediaQuery("(max-width: 1023px)");
  const profileCardRef = useRef<HTMLDivElement>(null);
  const accountSettingsCogRef = useRef<CogIconHandle | null>(null);
  const lightModeSunRef = useRef<SunIconHandle | null>(null);
  const darkModeMoonRef = useRef<MoonIconHandle | null>(null);
  const notificationsButtonRef = useRef<HTMLButtonElement>(null);
  const [cardWidth, setCardWidth] = useState<number | undefined>(undefined);
  const expandedWidthRef = useRef<number | undefined>(undefined);
  const lastCardWidthRef = useRef<number | undefined>(undefined);
  const lastBottomSectionHeightRef = useRef<number>(0);
  const lastLogoSectionHeightRef = useRef<number>(0);
  const profileWidthRafRef = useRef<number | null>(null);
  const bottomHeightRafRef = useRef<number | null>(null);
  const logoHeightRafRef = useRef<number | null>(null);
  const bottomSectionRef = useRef<HTMLDivElement>(null);
  const [bottomSectionHeight, setBottomSectionHeight] = useState<number>(0);
  const logoSectionRef = useRef<HTMLDivElement>(null);
  const [logoSectionHeight, setLogoSectionHeight] = useState<number>(0);
  const menuListRef = useRef<HTMLDivElement>(null);
  const notificationsMenuListRef = useRef<HTMLDivElement>(null);
  const { isOpen: isProfileMenuOpen, onOpen: onProfileMenuOpen, onClose: onProfileMenuClose } = useDisclosure();
  const { isOpen: isNotificationsMenuOpen, onOpen: onNotificationsMenuOpen, onClose: onNotificationsMenuClose } = useDisclosure();
  const {
    isOpen: isNotificationsModalOpen,
    onOpen: onNotificationsModalOpen,
    onClose: onNotificationsModalClose,
  } = useDisclosure();
  const { isOpen: isAccountModalOpen, onOpen: onAccountModalOpen, onClose: onAccountModalClose } = useDisclosure();
    const { resolvedTheme, setTheme } = useTheme();
    const isDark = resolvedTheme === "dark";

  // Sidebar notifications preview + modal state
  type SidebarNotificationPreview = {
    id: string;
    title: string;
    message: string;
    time: string;
    isRead: boolean;
    /** When true, `message` is plain text (not HTML from bodyMarkdown). */
    messageIsPlainText?: boolean;
  };
  const [sidebarNotifications, setSidebarNotifications] = useState<SidebarNotificationPreview[]>([]);
  const [sidebarUnreadCount, setSidebarUnreadCount] = useState(0);
  const [notificationModalFocusId, setNotificationModalFocusId] = useState<string | null>(null);

  // Get user's avatar image with fallback
  const avatarImage = user?.imageUrl || avatar4;
  
  // Get user's full name and email
  const fullName = user
    ? `${user.firstName || ""} ${user.lastName || ""}`.trim() || "User"
    : "User";
  const email = user?.primaryEmailAddress || user?.emailAddresses?.[0]?.emailAddress || "No email";
  
  // Measure card width after render (for dropdown menu width)
  // Store the expanded width and use it consistently
  useEffect(() => {
    const measureWidth = () => {
      if (profileCardRef.current) {
        const width = profileCardRef.current.offsetWidth;
        // Only update the expanded width when sidebar is not collapsed
        if (!isCollapsed) {
          expandedWidthRef.current = width;
          if (lastCardWidthRef.current !== width) {
            lastCardWidthRef.current = width;
            setCardWidth(width);
          }
        } else {
          // When collapsed, use the stored expanded width
          if (expandedWidthRef.current) {
            if (lastCardWidthRef.current !== expandedWidthRef.current) {
              lastCardWidthRef.current = expandedWidthRef.current;
              setCardWidth(expandedWidthRef.current);
            }
          }
        }
      }
    };
    
    // Measure immediately
    measureWidth();
    
    // Also measure after sidebar transition completes (0.2s + small buffer)
    const timeoutId = setTimeout(measureWidth, 300);
    
    // Use ResizeObserver to watch for size changes (only when expanded)
    let resizeObserver: ResizeObserver | null = null;
    if (profileCardRef.current && typeof ResizeObserver !== 'undefined' && !isCollapsed) {
      resizeObserver = new ResizeObserver(() => {
        if (profileWidthRafRef.current != null) cancelAnimationFrame(profileWidthRafRef.current);
        profileWidthRafRef.current = requestAnimationFrame(() => {
          profileWidthRafRef.current = null;
          measureWidth();
        });
      });
      resizeObserver.observe(profileCardRef.current);
    }
    
    return () => {
      clearTimeout(timeoutId);
      if (profileWidthRafRef.current != null) {
        cancelAnimationFrame(profileWidthRafRef.current);
        profileWidthRafRef.current = null;
      }
      if (resizeObserver && profileCardRef.current) {
        resizeObserver.disconnect();
      }
    };
  }, [fullName, email, isCollapsed]);

  // Measure bottom section height for scroll padding
  useEffect(() => {
    const measureHeight = () => {
      if (bottomSectionRef.current) {
        const height = bottomSectionRef.current.offsetHeight;
        // Add extra padding (16px) to ensure there's a clear gap between nav links and bottom section
        // This prevents overlap when scrolling
        const next = height + 16;
        if (lastBottomSectionHeightRef.current !== next) {
          lastBottomSectionHeightRef.current = next;
          setBottomSectionHeight(next);
        }
      }
    };
    
    measureHeight();
    // Use multiple timeouts to catch different render phases
    const timeoutId1 = setTimeout(measureHeight, 100);
    const timeoutId2 = setTimeout(measureHeight, 300);
    const timeoutId3 = setTimeout(measureHeight, 500);
    
    let resizeObserver: ResizeObserver | null = null;
    if (bottomSectionRef.current && typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(() => {
        if (bottomHeightRafRef.current != null) cancelAnimationFrame(bottomHeightRafRef.current);
        bottomHeightRafRef.current = requestAnimationFrame(() => {
          bottomHeightRafRef.current = null;
          measureHeight();
        });
      });
      resizeObserver.observe(bottomSectionRef.current);
    }
    
    return () => {
      clearTimeout(timeoutId1);
      clearTimeout(timeoutId2);
      clearTimeout(timeoutId3);
      if (bottomHeightRafRef.current != null) {
        cancelAnimationFrame(bottomHeightRafRef.current);
        bottomHeightRafRef.current = null;
      }
      if (resizeObserver && bottomSectionRef.current) {
        resizeObserver.disconnect();
      }
    };
  }, [isCollapsed, isResyncing, isProfileMenuOpen, isNotificationsMenuOpen]);

  // Measure logo section height
  useEffect(() => {
    const measureLogoHeight = () => {
      if (logoSectionRef.current) {
        const height = logoSectionRef.current.offsetHeight;
        if (lastLogoSectionHeightRef.current !== height) {
          lastLogoSectionHeightRef.current = height;
          setLogoSectionHeight(height);
        }
      }
    };
    
    measureLogoHeight();
    const timeoutId = setTimeout(measureLogoHeight, 100);
    
    let resizeObserver: ResizeObserver | null = null;
    if (logoSectionRef.current && typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(() => {
        if (logoHeightRafRef.current != null) cancelAnimationFrame(logoHeightRafRef.current);
        logoHeightRafRef.current = requestAnimationFrame(() => {
          logoHeightRafRef.current = null;
          measureLogoHeight();
        });
      });
      resizeObserver.observe(logoSectionRef.current);
    }
    
    return () => {
      clearTimeout(timeoutId);
      if (logoHeightRafRef.current != null) {
        cancelAnimationFrame(logoHeightRafRef.current);
        logoHeightRafRef.current = null;
      }
      if (resizeObserver && logoSectionRef.current) {
        resizeObserver.disconnect();
      }
    };
  }, [isCollapsed]);

  const loadSidebarNotificationsPreview = useCallback(
    async (params: FetchNotificationsParams = { limit: 5 }) => {
      try {
        const { notifications, unreadCount } = await fetchNotifications(params);

        const previews: SidebarNotificationPreview[] = notifications.map((n) => {
          const isPerfSummary = isPerformanceSummaryEventKey(n.eventKey);
          return {
            id: n.id,
            title: resolveNotificationDisplayTitle(n.title, n.eventKey ?? null, n.data),
            message: isPerfSummary
              ? getPerformanceSummaryPreviewText(n.data)
              : n.bodyMarkdown,
            time: new Date(n.createdAt).toLocaleString("en-US", {
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            }),
            isRead: n.statusInApp === "read",
            messageIsPlainText: isPerfSummary,
          };
        });

        setSidebarNotifications(previews);

        if (typeof unreadCount === "number") {
          setSidebarUnreadCount(unreadCount);
        } else {
          setSidebarUnreadCount(previews.filter((n) => !n.isRead).length);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to load sidebar notifications:", error);
      }
    },
    []
  );

  useEffect(() => {
    void loadSidebarNotificationsPreview({ limit: 5 });
  }, [loadSidebarNotificationsPreview]);

  const handleSidebarNotificationsUnreadChange = useCallback((count: number) => {
    // Update badge immediately from modal interactions.
    if (typeof count === "number") {
      setSidebarUnreadCount(Math.max(0, count));
    }
  }, []);

  // Proactive realtime updates from multiplexed /ws/signals notifications.
  useEffect(() => {
    let refreshTimeout: number | null = null;
    const onWsNotification = (evt: Event) => {
      const detail = (evt as CustomEvent).detail as { row?: any };
      const row = detail?.row;
      if (!row || !row.id) return;
      // Minimal upsert into preview list; full list remains source-of-truth via REST.
      setSidebarNotifications((prev) => {
        const createdAt = String(row.created_at ?? row.createdAt ?? new Date().toISOString());
        const nextItem: SidebarNotificationPreview = {
          id: String(row.id),
          title: String(row.title ?? "Notification"),
          message: String(row.body_markdown ?? row.bodyMarkdown ?? ""),
          time: new Date(createdAt).toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          }),
          isRead: String(row.status_in_app ?? row.statusInApp ?? "unread") === "read",
        };
        const without = prev.filter((n) => n.id !== nextItem.id);
        return [nextItem, ...without].slice(0, 5);
      });
      if (String(row.status_in_app ?? row.statusInApp ?? "unread") === "unread") {
        // Optimistic bump; we'll re-sync shortly to avoid drifting due to duplicates/out-of-order events.
        setSidebarUnreadCount((c) => c + 1);
      }
      if (refreshTimeout != null) {
        window.clearTimeout(refreshTimeout);
      }
      refreshTimeout = window.setTimeout(() => {
        refreshTimeout = null;
        void loadSidebarNotificationsPreview({ limit: 5 });
      }, 500);
    };
    window.addEventListener("notifications:ws", onWsNotification as any);
    return () => {
      window.removeEventListener("notifications:ws", onWsNotification as any);
      if (refreshTimeout != null) {
        window.clearTimeout(refreshTimeout);
      }
    };
  }, [loadSidebarNotificationsPreview]);

  // Close profile menu when notifications menu opens and vice versa
  useEffect(() => {
    if (isNotificationsMenuOpen && isProfileMenuOpen) {
      onProfileMenuClose();
    }
  }, [isNotificationsMenuOpen, isProfileMenuOpen, onProfileMenuClose]);

  useEffect(() => {
    if (isProfileMenuOpen && isNotificationsMenuOpen) {
      onNotificationsMenuClose();
    }
  }, [isProfileMenuOpen, isNotificationsMenuOpen, onNotificationsMenuClose]);

  // Calculate and position profile dropdown to align bottom edges
  useEffect(() => {
    if (!isProfileMenuOpen) {
      // Reset positioned state when menu closes
      if (menuListRef.current) {
        menuListRef.current.removeAttribute('data-positioned');
      }
      return;
    }
    
    if (!profileCardRef.current) return;

    const calculatePosition = () => {
      if (!profileCardRef.current || !menuListRef.current) {
        // Retry if refs aren't ready yet
        setTimeout(calculatePosition, 10);
        return;
      }

      const profileCardRect = profileCardRef.current.getBoundingClientRect();
      const menuListRect = menuListRef.current.getBoundingClientRect();
      
      // Only calculate if menu has dimensions
      if (menuListRect.width === 0 || menuListRect.height === 0) {
        // Retry after a short delay if menu isn't ready
        setTimeout(calculatePosition, 10);
        return;
      }
      
      // Calculate position: right side with gap, bottom edges aligned
      const left = profileCardRect.right + 16; // 16px gap
      const top = profileCardRect.bottom - menuListRect.height; // Align bottom edges
      
      menuListRef.current.style.position = 'fixed';
      menuListRef.current.style.left = `${left}px`;
      menuListRef.current.style.top = `${top}px`;
      menuListRef.current.style.right = 'auto';
      menuListRef.current.style.bottom = 'auto';
      menuListRef.current.setAttribute('data-positioned', 'true');
    };

    // Wait for next tick to ensure menu is rendered in Portal
    const timeoutId = setTimeout(calculatePosition, 0);
    
    // Also use requestAnimationFrame for more reliable timing
    const rafId = requestAnimationFrame(() => {
      calculatePosition();
    });
    
    // Recalculate on resize/scroll
    window.addEventListener('resize', calculatePosition);
    window.addEventListener('scroll', calculatePosition, true);
    
    // Close menu on outside click
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuListRef.current &&
        !menuListRef.current.contains(event.target as Node) &&
        profileCardRef.current &&
        !profileCardRef.current.contains(event.target as Node)
      ) {
        onProfileMenuClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      clearTimeout(timeoutId);
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', calculatePosition);
      window.removeEventListener('scroll', calculatePosition, true);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isProfileMenuOpen, fullName, email, cardWidth, onProfileMenuClose]);

  // Calculate and position notifications dropdown to align bottom edges
  useEffect(() => {
    if (!isNotificationsMenuOpen) {
      // Reset positioned state when menu closes
      if (notificationsMenuListRef.current) {
        notificationsMenuListRef.current.removeAttribute('data-positioned');
      }
      return;
    }
    
    if (!notificationsButtonRef.current) return;

    const calculatePosition = () => {
      if (!notificationsButtonRef.current || !notificationsMenuListRef.current) {
        // Retry if refs aren't ready yet
        setTimeout(calculatePosition, 10);
        return;
      }

      const buttonRect = notificationsButtonRef.current.getBoundingClientRect();
      const menuListRect = notificationsMenuListRef.current.getBoundingClientRect();
      
      // Only calculate if menu has dimensions
      if (menuListRect.width === 0 || menuListRect.height === 0) {
        // Retry after a short delay if menu isn't ready
        setTimeout(calculatePosition, 10);
        return;
      }
      
      // Calculate position: right side with gap, bottom edges aligned
      const left = buttonRect.right + 16; // 16px gap
      const top = buttonRect.bottom - menuListRect.height; // Align bottom edges
      
      notificationsMenuListRef.current.style.position = 'fixed';
      notificationsMenuListRef.current.style.left = `${left}px`;
      notificationsMenuListRef.current.style.top = `${top}px`;
      notificationsMenuListRef.current.style.right = 'auto';
      notificationsMenuListRef.current.style.bottom = 'auto';
      notificationsMenuListRef.current.setAttribute('data-positioned', 'true');
    };

    // Wait for next tick to ensure menu is rendered in Portal
    const timeoutId = setTimeout(calculatePosition, 0);
    
    // Also use requestAnimationFrame for more reliable timing
    const rafId = requestAnimationFrame(() => {
      calculatePosition();
    });
    
    // Recalculate on resize/scroll
    window.addEventListener('resize', calculatePosition);
    window.addEventListener('scroll', calculatePosition, true);
    
    // Close menu on outside click
    const handleClickOutside = (event: MouseEvent) => {
      if (
        notificationsMenuListRef.current &&
        !notificationsMenuListRef.current.contains(event.target as Node) &&
        notificationsButtonRef.current &&
        !notificationsButtonRef.current.contains(event.target as Node)
      ) {
        onNotificationsMenuClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      clearTimeout(timeoutId);
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', calculatePosition);
      window.removeEventListener('scroll', calculatePosition, true);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isNotificationsMenuOpen, onNotificationsMenuClose]);

  // Handle profile navigation
  const handleProfileClick = () => {
    const currentPath = `${location.pathname}${location.search}`;
    if (!currentPath.startsWith("/profile")) {
      window.sessionStorage.setItem(ACCOUNT_SETTINGS_RETURN_PATH_KEY, currentPath);
    }
    history.push({
      pathname: accountSettingsTabPath("general"),
      state: { fromSidebarPath: currentPath },
    });
  };
  const triggerAccountSettingsCogAnimation = useCallback(() => {
    void accountSettingsCogRef.current?.startAnimation();
  }, []);
  const onAccountSettingsMenuClick = useCallback(() => {
    triggerAccountSettingsCogAnimation();
    handleProfileClick();
    onProfileMenuClose();
    window.setTimeout(() => {
      void accountSettingsCogRef.current?.stopAnimation();
    }, 260);
  }, [onProfileMenuClose, triggerAccountSettingsCogAnimation]);
  const triggerThemeIconAnimation = useCallback(() => {
    if (isDark) {
      void darkModeMoonRef.current?.startAnimation();
      return;
    }
    void lightModeSunRef.current?.startAnimation();
  }, [isDark]);
  const onToggleColorModeFromMenu = useCallback(() => {
    triggerThemeIconAnimation();
    setTheme(isDark ? "light" : "dark");
    window.setTimeout(() => {
      void darkModeMoonRef.current?.stopAnimation();
      void lightModeSunRef.current?.stopAnimation();
    }, 260);
  }, [isDark, setTheme, triggerThemeIconAnimation]);

  const handleBackFromAccountSettings = () => {
    const statePath = locationState.fromSidebarPath;
    const storedPath = window.sessionStorage.getItem(ACCOUNT_SETTINGS_RETURN_PATH_KEY);
    const returnPath = [statePath, storedPath].find(
      (path): path is string => !!path && !path.startsWith("/profile")
    ) || "/dashboard";

    window.sessionStorage.removeItem(ACCOUNT_SETTINGS_RETURN_PATH_KEY);
    history.push(returnPath);
  };

  // Handle sign out
  const handleSignOut = async () => {
    setIsSigningOut(true);
    try {
      await signOut();
      window.location.assign("/auth/signin");
    } catch (error) {
      console.error("Sign out error:", error);
      setIsSigningOut(false);
    }
  };

  const handleSwitchAccount = async (brokerName: string, accountCode: string) => {
    if (brokerName === activeBrokerName && accountCode === activeAccountCode) return;
    setIsSwitchingAccount(true);
    try {
      await setActiveTradeAccount(brokerName, accountCode);
      const label = brokerAccounts.find(
        (a: { accountCode: string; brokerName: string }) =>
          a.accountCode === accountCode && a.brokerName === brokerName
      );
      const displayName = label ? formatAccountDisplayLabel(label) : accountCode;
      toast.success("Switched account", {
        description: `Now viewing ${displayName}`,
      });
    } catch (e) {
      presentMutationError(e, "Failed to switch account");
    } finally {
      setIsSwitchingAccount(false);
    }
  };

  const handleSidebarResyncTrades = async () => {
    if (!isLoaded || !user?.id) {
      toastError("Authentication required", {
        description: "Please log in to sync trades.",
      });
      return;
    }

    const accountCode = activeAccountCode;

    if (!accountCode || !activeBrokerName) {
      const currentPath = `${location.pathname}${location.search}`;
      if (!currentPath.startsWith("/profile")) {
        window.sessionStorage.setItem(ACCOUNT_SETTINGS_RETURN_PATH_KEY, currentPath);
      }
      toastWarning("No synced trade account found", {
        description: "Please connect and sync a trade account from the Broker Management page first.",
      });
      history.push({
        pathname: accountSettingsTabPath("broker-api"),
        state: { fromSidebarPath: currentPath },
      });
      return;
    }

    setResyncing(true);
    try {
      const result = await syncTradesFromBroker(accountCode, undefined, undefined, activeBrokerName);
      const stats = result?.sync_stats ?? { created: 0, updated: 0, skipped: 0, total: 0 };

      const syncStatus = await afterBrokerResyncWaitForAnalytics({
        accountCode,
        brokerName: activeBrokerName,
        userId: user.id,
        action: "sync",
        refetchBrokerAccounts,
      });

      if (syncStatus.phase === "needs_instrument_setup") {
        toast.info("Instrument setup required", {
          description: "Sync completed. Resolve pending symbols before dashboard analytics can load.",
        });
        await runInstrumentSetupAfterSync(syncStatus, syncStatus.account_code || accountCode, {
          skipTradeAccountsRefetch: true,
        });
        return;
      }

      const message =
        result?.sync_stats == null
          ? "Trades synced successfully."
          : stats.created > 0 || stats.updated > 0
            ? `Synced ${stats.total} order(s): ${stats.created} trades created, ${stats.updated} trades updated, ${stats.skipped} skipped`
            : `All ${stats.total} order(s) are already up to date`;

      toast.success("Re-sync successful", {
        description: `${message} (${syncStatus.closed_trades} closed, ${syncStatus.open_trades} open).`,
      });
      await runInstrumentSetupAfterSync(result, accountCode, {
        skipTradeAccountsRefetch: true,
      });
    } catch (error: unknown) {
      presentMutationError(error, "Re-sync failed");
    } finally {
      setResyncing(false);
    }
  };

  // Color mode values
  const navbarIcon = useColorModeValue("gray.500", "gray.200");
  const cardBg = useColorModeValue("white", "#151517");
  const cardBorder = useColorModeValue("gray.200", "gray.600");
  const notificationRowHoverBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const cardText = useColorModeValue("gray.700", "gray.200");
  const cardTextSecondary = useColorModeValue("gray.500", "gray.400");
  const cardHoverBg = useColorModeValue("gray.50", "gray.700");
  const cardHoverBorder = useColorModeValue("gray.300", "gray.500");
  const cardActiveBg = useColorModeValue("gray.100", "gray.600");
  const accountBorderColor = useColorModeValue("gray.200", "gray.600");
  const accountIconColor = useColorModeValue("gray.600", "gray.300");
  const accountLabelColor = useColorModeValue("gray.500", "gray.400");
  const accountButtonBg = useColorModeValue("white", "#151517");
  const accountButtonHoverBg = useColorModeValue("gray.100", "gray.700");

    // to check for active links and opened collapses
  let location = useLocation();
  const isAccountSettingsView =
    location.pathname === "/profile" ||
    location.pathname.startsWith("/profile/");
  const accountTabFromSearch = resolveAccountSettingsTabId(
    location.pathname,
    location.search
  );
  const locationState = (location.state || {}) as { fromSidebarPath?: string };
  // this is for the rest of the collapses
  const [state, setState] = useState<{ [key: string]: boolean }>({});

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName: string): string => {
    return location.pathname === routeName ? "active" : "";
  };
  
  const createLinks = (routes: RouteConfigArray): (JSX.Element | null)[] => {
    if (!routes || !Array.isArray(routes) || routes.length === 0) {
      return [];
    }
    const inactiveColor = useColorModeValue("gray.400", "white");

    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.hideFromSidebar) {
        return null;
      }
      // Skip account category (ACCOUNT PAGES)
      if (prop.category === "account") {
        return null;
      }
      // Skip RTL route
      if (prop.layout === "/rtl") {
        return null;
      }
      // Skip course overview route (it's accessed via university page, not directly)
      if (prop.path && prop.path.startsWith("/university/course")) {
        return null;
      }
      // Hide Tradar route if user doesn't have access
      if (prop.path === "/tradar" && !hasTradarAccess) {
        return null;
      }
      // Hide Admin route if user is not an admin
      if (prop.path === "/system" && !isAdmin) {
        return null;
      }
      // Skip journal route
      if (prop.path === "/journal") {
        return null;
      }
      if (prop.category && prop.views) {
        const st: { [key: string]: boolean } = {};
        if (prop.state) {
          st[prop.state] = !state[prop.state];
        }
        return (
          <div key={prop.name || key}>
            <Text
              color={useColorModeValue("#D3D3D3", "white")}
              fontWeight="bold"
              mb={{
                xl: "12px",
              }}
              mx="auto"
              ps="16px"
              py="12px"
              opacity={isCollapsed ? 0 : 1}
              width={isCollapsed ? 0 : "auto"}
              overflow="hidden"
              whiteSpace="nowrap"
              transition="opacity 0.2s ease-linear, width 0.2s ease-linear"
              pointerEvents={isCollapsed ? "none" : "auto"}
            >
              {document.documentElement.dir === "rtl"
                ? prop.rtlName
                : prop.name}
            </Text>
            {createLinks(prop.views)}
          </div>
        );
      }
      if (!prop.path || prop.layout == null) {
        return null;
      }
      // Skip auth routes (sign in/sign up) - they shouldn't appear in the sidebar
      if (prop.layout === "/auth") {
        return null;
      }
      // Skip detail/parameterized routes in sidebar nav.
      if (prop.path.includes(":")) {
        return null;
      }
      const routePath = `${prop.layout || ""}${prop.path}`;
      return (
        <SidebarNavRouteRow
          key={prop.name || key}
          routePath={routePath}
          prop={prop}
          variant="desktop"
          isCollapsed={isCollapsed}
          inactiveColor={inactiveColor}
          activeRoute={activeRoute}
        />
      );
    });
  };

  const createAccountSettingsLinks = (): JSX.Element[] => {
    const activeBg = "linear-gradient(135deg, #38BBD1, #3EEAEC)";
    const activeColor = "white";
    const inactiveColor = useColorModeValue("gray.400", "white");
    const tabs =
      billingLoading || isTier1Granted
        ? ACCOUNT_SETTINGS_TABS
        : ACCOUNT_SETTINGS_TABS.filter((tab) =>
            isProfileTabAllowedWithoutTier1(tab.id)
          );

    return tabs.map((tab) => (
      <AccountSettingsTabLink
        key={tab.id}
        tab={tab}
        isActive={accountTabFromSearch === tab.id}
        isCollapsed={isCollapsed}
        activeBg={activeBg}
        activeColor={activeColor}
        inactiveColor={inactiveColor}
      />
    ));
  };

  const links = isAccountSettingsView ? createAccountSettingsLinks() : createLinks(routes);

  return (
    // @ts-ignore - Chakra UI complex union type
    <Flex
      direction="column"
      flex="1"
      h="100%"
      minH="0"
      position="relative"
      overflow="hidden"
    >
      <Box ref={logoSectionRef} pt={"25px"} mb="12px" flexShrink={0}>
      <NavLink
        to="/dashboard"
        style={{
          display: "flex",
          lineHeight: "100%",
          marginBottom: "30px",
          fontWeight: "bold",
          justifyContent: isCollapsed ? "center" : "flex-start",
          alignItems: "center",
          fontSize: "11px",
          paddingLeft: "0",
          marginLeft: isCollapsed ? "0" : "8px",
          transition: "all 0.2s ease-linear",
          textDecoration: "none",
        }}
      >
        <Image
          src={getSidebarBrandLogoSrc(isCollapsed)}
          alt="Tessera"
          maxW={isCollapsed ? SIDEBAR_BRAND_LOGO_COLLAPSED_SIZE : SIDEBAR_BRAND_LOGO_EXPANDED_MAX_WIDTH}
          w={isCollapsed ? SIDEBAR_BRAND_LOGO_COLLAPSED_SIZE : "auto"}
          maxH={isCollapsed ? SIDEBAR_BRAND_LOGO_COLLAPSED_SIZE : SIDEBAR_BRAND_LOGO_EXPANDED_MAX_HEIGHT}
          h="auto"
          objectFit="contain"
          transition="all 0.2s ease-linear"
        />
      </NavLink>
      <Box
        borderBottom="1px solid"
        borderColor={useColorModeValue("gray.200", "gray.700")}
        mb="12px"
      />
    </Box>
    {/* Scrollable nav links container - only this section scrolls, constrained to not overlap bottom buttons */}
    <Box
      flex="1"
      minH="0"
      maxH={logoSectionHeight > 0 && bottomSectionHeight > 0 
        ? `calc(100vh - ${logoSectionHeight}px - ${bottomSectionHeight}px - 16px)` 
        : logoSectionHeight > 0 
        ? `calc(100vh - ${logoSectionHeight}px - 266px)` 
        : bottomSectionHeight > 0 
        ? `calc(100vh - 100px - ${bottomSectionHeight}px - 16px)` 
        : "calc(100vh - 366px)"}
      overflowY="auto"
      overflowX="hidden"
      pr="4px"
      sx={{
        "@keyframes sidebarModeSwap": {
          "0%": { opacity: 0, transform: "translateX(-6px)" },
          "100%": { opacity: 1, transform: "translateX(0)" },
        },
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          background: isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: isDark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
        },
      }}
    >
      <Box key={isAccountSettingsView ? "account-mode" : "default-mode"} animation="sidebarModeSwap 220ms ease">
        {isAccountSettingsView && (
          <Button
            w={isCollapsed ? "44px" : "100%"}
            h={isCollapsed ? "44px" : "40px"}
            mb="12px"
            borderRadius={isCollapsed ? "10px" : "15px"}
            justifyContent={isCollapsed ? "center" : "flex-start"}
            leftIcon={isCollapsed ? undefined : <Icon as={FiArrowLeft} w="16px" h="16px" />}
            onClick={handleBackFromAccountSettings}
            variant="ghost"
            color={cardTextSecondary}
            _hover={{ bg: cardHoverBg }}
            px={isCollapsed ? 0 : "16px"}
            mx="auto"
            display="flex"
          >
            {isCollapsed ? <Icon as={FiArrowLeft} w="18px" h="18px" /> : "Back"}
          </Button>
        )}
        <Stack direction="column" spacing={0} w="100%">
          {links}
        </Stack>
      </Box>
    </Box>

    {/* Bottom section: Re-sync trade account button and navigation */}
    <Box
      ref={bottomSectionRef}
      position="absolute"
      bottom="0"
      left="0"
      right="0"
      px={isCollapsed ? 0 : 4}
      pb="14px"
    >
      {isCollapsed ? (
        <>
        <VStack spacing="8px" w="100%" align="center">
          {brokerConnected && brokerAccounts.length > 0 && (
            <Button
              w="40px"
              h="40px"
              minW="40px"
              borderRadius="6px"
              border="1px solid"
              borderColor={accountBorderColor}
              bg={accountButtonBg}
              _hover={{ opacity: 0.9 }}
              isLoading={isSwitchingAccount}
              title="Switch trade account"
              onClick={onAccountModalOpen}
            >
              <Icon as={MdAccountBalance} w={4} h={4} color={accountIconColor} />
            </Button>
          )}
          {showSidebarResyncTrades ? (
          <Button
            w="40px"
            h="40px"
            minW="40px"
            bgGradient="linear(135deg, #38BBD1, #3EEAEC)"
            color="white"
            borderRadius="6px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            mx="auto"
            onClick={handleSidebarResyncTrades}
            isLoading={isResyncing}
            _hover={{ opacity: 0.95 }}
            _active={{ opacity: 0.9 }}
          >
            <Icon as={MdSync} w={4} h={4} />
          </Button>
          ) : null}
          <Button
            w="40px"
            h="40px"
            minW="40px"
            borderRadius="12px"
            border="1px solid"
            borderColor={useColorModeValue("gray.300", "gray.600")}
            bg="transparent"
            _hover={{ opacity: 0.9 }}
            title="Notifications"
            onClick={() => {
              setNotificationModalFocusId(null);
              onNotificationsModalOpen();
            }}
            position="relative"
          >
            <Icon as={AiOutlineBell} w={4} h={4} color={accountIconColor} />
            {sidebarUnreadCount > 0 && (
              <Box
                position="absolute"
                top="7px"
                right="7px"
                w="7px"
                h="7px"
                borderRadius="full"
                bg="#FE4244"
              />
            )}
          </Button>
          <Button
            w="40px"
            h="40px"
            minW="40px"
            borderRadius="12px"
            border="none"
            bg="transparent"
            _hover={{ opacity: 0.9 }}
            title="Account & Settings"
            onClick={handleProfileClick}
            p={0}
            overflow="hidden"
          >
            <Avatar
              src={avatarImage}
              name={fullName}
              size="sm"
              w="40px"
              h="40px"
              borderRadius="6px"
            />
          </Button>
        </VStack>
        <NotificationModal
          isOpen={isNotificationsModalOpen}
          onClose={() => {
            setNotificationModalFocusId(null);
            onNotificationsModalClose();
            void loadSidebarNotificationsPreview({ limit: 5 });
          }}
          initialFocusNotificationId={notificationModalFocusId}
          onUnreadCountChange={handleSidebarNotificationsUnreadChange}
        />
        </>
      ) : (
        <>
          {brokerConnected && brokerAccounts.length > 0 && (
            <Box mb="12px">
              <Text fontSize="xs" fontWeight="medium" color={accountLabelColor} mb="6px" fontFamily="'IBM Plex Sans', sans-serif">
                Trade account
              </Text>
              <Button
                size="sm"
                w="100%"
                h="40px"
                justifyContent="space-between"
                rightIcon={<Icon as={MdAccountBalance} w={3.5} h={3.5} color="#A0AEC0" />}
                borderRadius="6px"
                border="1px solid"
                borderColor={accountBorderColor}
                bg={accountButtonBg}
                color="#A0AEC0"
                fontSize="xs"
                fontFamily="'IBM Plex Sans', sans-serif"
                fontWeight="medium"
                textTransform="uppercase"
                isDisabled={accountsLoading || isSwitchingAccount}
                onClick={onAccountModalOpen}
                _hover={{ bg: accountButtonHoverBg }}
                overflow="hidden"
              >
                <Text as="span" noOfLines={1} overflow="hidden" textOverflow="ellipsis" minW={0} flex={1} display="block">
                  {(() => {
                    if (accountsLoading) return "Loading...";
                    const current = brokerAccounts.find(
                      (a: { accountCode: string; brokerName: string }) =>
                        a.accountCode === activeAccountCode && a.brokerName === activeBrokerName
                    );
                    if (!current) return activeAccountCode ?? "Select account";
                    const fromCustom = current.customName?.trim();
                    if (fromCustom) return fromCustom;
                    if ("tradeLabel" in current && (current as { tradeLabel?: string }).tradeLabel) {
                      return (current as { tradeLabel: string }).tradeLabel;
                    }
                    return formatAccountDisplayLabelShort(current);
                  })()}
                </Text>
              </Button>
              {isSwitchingAccount && (
                <Flex align="center" gap="6px" mt="6px">
                  <Spinner size="xs" />
                  <Text fontSize="xs" color={accountLabelColor}>Switching...</Text>
                </Flex>
              )}
            </Box>
          )}
          {brokerConnected && brokerAccounts.length === 0 && !accountsLoading && (
            <Link
              as={NavLink}
              to="/profile"
              fontSize="xs"
              color={useColorModeValue("cyan.600", "cyan.400")}
              mb="12px"
              display="block"
            >
              Connect broker
            </Link>
          )}
          {!brokerConnected && !accountsLoading && (
            <Link
              as={NavLink}
              to="/profile"
              fontSize="xs"
              color={useColorModeValue("cyan.600", "cyan.400")}
              mb="12px"
              display="block"
            >
              Connect broker
            </Link>
          )}
          {showSidebarResyncTrades ? (
          <GradientButton
            w="100%"
            showArrow={false}
            fontSize="xs"
            px="20px"
            py="10px"
            h="40px"
            borderRadius="6px"
            onClick={handleSidebarResyncTrades}
            isLoading={isResyncing}
            loadingText="Re-syncing..."
            mb="12px"
          >
            Re-sync Trade Account
          </GradientButton>
          ) : null}

          {/* NavSecondary: Notifications */}
          <VStack spacing="2px" mb="12px" align="stretch">
            <Box position="relative">
              <Box
                ref={notificationsButtonRef as any}
                as="button"
                w="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                px="20px"
                py="10px"
                h="40px"
                borderRadius="6px"
                border="1px solid"
                borderColor={useColorModeValue("gray.300", "gray.600")}
                bg="transparent"
                color="#9CA3AF"
                fontSize="xs"
                fontFamily="'IBM Plex Sans', sans-serif"
                fontWeight="medium"
                textTransform="uppercase"
                cursor="pointer"
                transition="all 0.2s"
                _hover={{ 
                  borderColor: useColorModeValue("gray.400", "gray.500"),
                  opacity: 0.9
                }}
                _active={{ 
                  opacity: 0.8,
                  transform: "scale(0.98)"
                }}
                onClick={isNotificationsMenuOpen ? onNotificationsMenuClose : onNotificationsMenuOpen}
              >
                <Icon as={AiOutlineBell} w="16px" h="16px" mr="8px" flexShrink={0} />
                <Text
                  color="#9CA3AF"
                  fontSize="xs"
                  fontFamily="'IBM Plex Sans', sans-serif"
                  fontWeight="medium"
                  textTransform="uppercase"
                >
                  Notifications
                </Text>
              </Box>
              {sidebarUnreadCount > 0 && (
                <Box
                  position="absolute"
                  top="8px"
                  right="12px"
                  w="7px"
                  h="7px"
                  borderRadius="full"
                  bg="#FE4244"
                />
              )}
              
              {isNotificationsMenuOpen && (
                <Portal>
                  <Box
                    ref={notificationsMenuListRef}
                    position="fixed"
                    minW="280px"
                    maxW="320px"
                    maxH="400px"
                    bg={cardBg}
                    border="1px solid"
                    borderColor={cardBorder}
                    borderRadius="8px"
                    boxShadow="lg"
                    p={0}
                    zIndex={1000}
                    overflowY="auto"
                  >
                    {/* Notifications Header */}
                    <Flex
                      p="12px"
                      borderBottom="1px solid"
                      borderColor={cardBorder}
                      align="center"
                      justify="space-between"
                      gap={2}
                    >
                      <Text
                        fontSize="sm"
                        fontWeight="semibold"
                        color="#9CA3AF"
                        fontFamily="'Urbanist', sans-serif"
                      >
                        Notifications
                      </Text>
                      <Box
                        as="button"
                        type="button"
                        fontSize="xs"
                        fontFamily="'Urbanist', sans-serif"
                        color={cardTextSecondary}
                        bg="transparent"
                        _hover={{ color: cardText }}
                        onClick={() => {
                          const currentPath = `${location.pathname}${location.search}`;
                          if (
                            !currentPath.startsWith("/profile") &&
                            !currentPath.startsWith("/notifications")
                          ) {
                            window.sessionStorage.setItem(
                              NOTIFICATIONS_CENTRE_RETURN_PATH_KEY,
                              currentPath
                            );
                          }
                          onNotificationsMenuClose();
                          history.push(notificationsCentrePath());
                        }}
                      >
                        View all notifications
                      </Box>
                    </Flex>
                    
                    {/* Notifications List */}
                    <Box>
                      {sidebarNotifications.length === 0 ? (
                        <Box p="24px" textAlign="center">
                          <Text
                            fontSize="sm"
                            color="#9CA3AF"
                            fontFamily="'Urbanist', sans-serif"
                          >
                            No notifications
                          </Text>
                        </Box>
                      ) : (
                        <>
                          {sidebarNotifications.map((notification, index) => {
                            const total = sidebarNotifications.length;
                            const isLast = index + 1 === total;
                            return (
                              <Box
                                key={notification.id}
                                as="button"
                                type="button"
                                w="100%"
                                textAlign="left"
                                px="16px"
                                py="12px"
                                borderBottom={isLast ? "none" : "1px solid"}
                                borderColor={cardBorder}
                                cursor="pointer"
                                bg="transparent"
                                transition="background 0.15s ease"
                                _hover={{ bg: notificationRowHoverBg }}
                                onClick={() => {
                                  setNotificationModalFocusId(notification.id);
                                  onNotificationsMenuClose();
                                  onNotificationsModalOpen();
                                }}
                              >
                                <Flex direction="column" align="flex-start" gap={1}>
                                  <Flex
                                    align="center"
                                    justify="space-between"
                                    w="100%"
                                  >
                                    <Text
                                      fontSize="sm"
                                      fontWeight={notification.isRead ? "normal" : "semibold"}
                                      color={notification.isRead ? "#9CA3AF" : cardText}
                                      fontFamily="'Urbanist', sans-serif"
                                      noOfLines={1}
                                    >
                                      {notification.title}
                                    </Text>
                                    {!notification.isRead && (
                                      <Box
                                        w="8px"
                                        h="8px"
                                        borderRadius="full"
                                        bg={cardText}
                                        flexShrink={0}
                                      />
                                    )}
                                  </Flex>
                                  {notification.messageIsPlainText ? (
                                    <Text
                                      fontSize="xs"
                                      color={cardTextSecondary}
                                      fontFamily="'Urbanist', sans-serif"
                                      noOfLines={3}
                                    >
                                      {notification.message}
                                    </Text>
                                  ) : (
                                    <Box
                                      fontSize="xs"
                                      color={cardTextSecondary}
                                      fontFamily="'Urbanist', sans-serif"
                                      noOfLines={2}
                                      sx={{
                                        "& p": { margin: 0 },
                                        "& p + p": { marginTop: "0.25em" },
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: notification.message || "",
                                      }}
                                    />
                                  )}
                                  <Text
                                    fontSize="xs"
                                    color={cardTextSecondary}
                                    fontFamily="'Urbanist', sans-serif"
                                  >
                                    {notification.time}
                                  </Text>
                                </Flex>
                              </Box>
                            );
                          })}
                        </>
                      )}

                    </Box>
                  </Box>
                </Portal>
              )}
            </Box>
          </VStack>

          {/* Notifications modal (full centre) */}
          <NotificationModal
            isOpen={isNotificationsModalOpen}
            onClose={() => {
              setNotificationModalFocusId(null);
              onNotificationsModalClose();
              void loadSidebarNotificationsPreview({ limit: 5 });
            }}
            initialFocusNotificationId={notificationModalFocusId}
            onUnreadCountChange={handleSidebarNotificationsUnreadChange}
          />

          {/* NavUser: Profile section */}
          <Box position="relative">
            <Box
              w="100%"
              h="auto"
              p="8px"
              borderRadius="6px"
              cursor="pointer"
              transition="background 0.2s"
              bg={isProfileMenuOpen ? cardActiveBg : "transparent"}
              _hover={{ bg: cardHoverBg }}
              _active={{ bg: cardActiveBg }}
              ref={profileCardRef}
              onClick={isProfileMenuOpen ? onProfileMenuClose : onProfileMenuOpen}
            >
              <Flex alignItems="center" w="100%" justifyContent="space-between">
                <Flex alignItems="center" flex="1" minW="0">
                  <Avatar
                    src={avatarImage}
                    name={fullName}
                    size="sm"
                    w="32px"
                    h="32px"
                    mr="12px"
                    flexShrink={0}
                    borderRadius="6px"
                  />
                  <Box flex="1" textAlign="left" minW="0">
                    <Text
                      fontSize="sm"
                      fontWeight="medium"
                      color={cardText}
                      fontFamily="'Urbanist', sans-serif"
                      isTruncated
                    >
                      {fullName}
                    </Text>
                    <Text
                      fontSize="xs"
                      color={cardTextSecondary}
                      fontFamily="'Urbanist', sans-serif"
                      isTruncated
                    >
                      {email}
                    </Text>
                  </Box>
                </Flex>
                <Icon
                  as={AiOutlineMore}
                  w="16px"
                  h="16px"
                  color={cardTextSecondary}
                  flexShrink={0}
                  ml="8px"
                />
              </Flex>
            </Box>
            
            {isProfileMenuOpen && (
              <Portal>
                <Box
                  ref={menuListRef}
                  position="fixed"
                  minW={cardWidth || "200px"}
                  bg={cardBg}
                  border="1px solid"
                  borderColor={cardBorder}
                  borderRadius="8px"
                  boxShadow="lg"
                  p={0}
                  zIndex={1000}
                >
                  <svg width="0" height="0" style={{ position: 'absolute' }}>
                    <defs>
                      <linearGradient id="iconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#38BBD1" />
                        <stop offset="100%" stopColor="#3EEAEC" />
                      </linearGradient>
                      <linearGradient id="logoutIconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#E00101" />
                        <stop offset="100%" stopColor="#FE4244" />
                      </linearGradient>
                    </defs>
                  </svg>
                  {/* User Profile Section at Top */}
                  <Box p="12px" borderBottom="1px solid" borderColor={cardBorder}>
                    <Flex alignItems="center">
                      <Avatar
                        src={avatarImage}
                        name={fullName}
                        size="sm"
                        w="32px"
                        h="32px"
                        mr="12px"
                        flexShrink={0}
                        borderRadius="6px"
                      />
                      <Box flex="1" minW="0">
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="#9CA3AF"
                          fontFamily="'Urbanist', sans-serif"
                          isTruncated
                        >
                          {fullName}
                        </Text>
                        <Text
                          fontSize="xs"
                          color="#9CA3AF"
                          fontFamily="'Urbanist', sans-serif"
                          isTruncated
                        >
                          {email}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                  
                  <Box>
                    <Box
                      as="button"
                      w="100%"
                      display="flex"
                      alignItems="center"
                      px="12px"
                      py="8px"
                      onPointerDownCapture={triggerAccountSettingsCogAnimation}
                      onClick={onAccountSettingsMenuClick}
                      bg="transparent"
                      _hover={{ bg: cardHoverBg }}
                      fontFamily="'Urbanist', sans-serif"
                      fontSize="sm"
                      color="#9CA3AF"
                    >
                      <Box
                        display="inline-flex"
                        alignItems="center"
                        justifyContent="center"
                        w="16px"
                        h="16px"
                        mr="12px"
                        sx={{
                          '& svg': {
                            width: '16px',
                            height: '16px',
                          }
                        }}
                      >
                        <CogIcon ref={accountSettingsCogRef} size={16} />
                      </Box>
                      Account & Settings
                    </Box>
                    <Box
                      w="100%"
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      px="12px"
                      py="8px"
                      bg="transparent"
                      _hover={{ bg: cardHoverBg }}
                    >
                      <Flex
                        as="button"
                        type="button"
                        align="center"
                        minW={0}
                        onPointerDownCapture={triggerThemeIconAnimation}
                        onClick={onToggleColorModeFromMenu}
                      >
                        <Box
                          display="inline-flex"
                          alignItems="center"
                          justifyContent="center"
                          w="16px"
                          h="16px"
                          mr="12px"
                          color="#9CA3AF"
                        >
                          {isDark ? (
                            <MoonIcon ref={darkModeMoonRef} size={16} />
                          ) : (
                            <SunIcon ref={lightModeSunRef} size={16} />
                          )}
                        </Box>
                        <Text
                          fontFamily="'Urbanist', sans-serif"
                          fontSize="sm"
                          color="#9CA3AF"
                        >
                          Light/Dark Mode
                        </Text>
                      </Flex>
                      <Switch
                        isChecked={isDark}
                        onClick={(e) => e.stopPropagation()}
                        onChange={onToggleColorModeFromMenu}
                        size="md"
                        sx={{
                          '& .chakra-switch__track[data-checked]': {
                            bg: 'linear-gradient(135deg, #38BBD1, #3EEAEC) !important',
                          }
                        }}
                      />
                    </Box>
                    <Box
                      h="1px"
                      bg={cardBorder}
                      mx="12px"
                      my="4px"
                    />
                    <Box
                      as="button"
                      w="100%"
                      display="flex"
                      alignItems="center"
                      px="12px"
                      py="8px"
                      onClick={() => {
                        if (!isSigningOut) {
                          handleSignOut();
                          onProfileMenuClose();
                        }
                      }}
                      disabled={isSigningOut}
                      bg="transparent"
                      _hover={{ bg: cardHoverBg }}
                      fontFamily="'Urbanist', sans-serif"
                      fontSize="sm"
                      cursor={isSigningOut ? "not-allowed" : "pointer"}
                      opacity={isSigningOut ? 0.5 : 1}
                    >
                      <Box
                        display="inline-flex"
                        alignItems="center"
                        justifyContent="center"
                        w="16px"
                        h="16px"
                        mr="12px"
                        sx={{
                          '& svg': {
                            fill: 'url(#logoutIconGradient)',
                            width: '16px',
                            height: '16px',
                          }
                        }}
                      >
                        <Icon as={AiOutlineLogout} w="16px" h="16px" />
                      </Box>
                      <Box
                        bgGradient="linear-gradient(135deg, #E00101, #FE4244)"
                        bgClip="text"
                        color="transparent"
                      >
                        {isSigningOut ? "Signing out..." : "Log out"}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Portal>
            )}
          </Box>
        </>
      )}
    </Box>
    <AccountSelectorModal
      isOpen={isAccountModalOpen}
      onClose={onAccountModalClose}
      accounts={brokerAccounts}
      activeAccountCode={activeAccountCode}
      activeBrokerName={activeBrokerName}
      onSelectAccount={handleSwitchAccount}
      onRefetchAccounts={refetchBrokerAccounts}
      onAccountRemoved={removeTradeAccount}
      loading={accountsLoading}
      isSwitching={isSwitchingAccount}
      isConnected={brokerConnected}
    />
    </Flex>
  );
}

export default SidebarContent

